import { createStore, applyMiddleware, combiReducers } from 'redux'
import thunk from 'redux-thunk'
import { configureStore } from '@reduxjs/toolkit'
import rootReducer from '../reducers'

import authSlice from 'app/store/authSlice'
import profileSlice from 'app/store/profileSlice'
import jobSlice from 'app/store/jobSlice'
import candidateSlice from 'app/store/candidateSlice'
import applicantsSlice from 'app/store/applicantsSlice'
import inviteSlice from 'app/store/inviteSlice'
import chatSlice from 'app/store/chatSlice'
import refreshReducer from 'app/store/refreshSlice'
import engagementPromoReducer from 'app/store/engagementPromoSlice'

// const store = createStore(rootReducer, applyMiddleware(thunk));

export const store = configureStore({
  reducer: {
    auth: authSlice,
    profile: profileSlice,
    job: jobSlice,
    candidate: candidateSlice,
    applicants: applicantsSlice,
    invite: inviteSlice,
    chat: chatSlice,
    refresh: refreshReducer,
    engagementPromo: engagementPromoReducer,
  },
})

export default store
